module.exports = __webpack_public_path__ + "media/app/images/figma-b22fbe6286d1ca2df2d7f086a16db61a.png";